export default class StartupEvent {

    constructor(type) {
        this.type = type;
    }
}

StartupEvent.PROGRESS = "StartupEvent.PROGRESS";
StartupEvent.COMPLETE = "StartupEvent.COMPLETE";